import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { Config } from '../models/config.model';
import { SiteService } from './site.service';
@Injectable()
export class ApiUrlService {
  constructor(private siteService: SiteService) {
  }

  baseUrl(includeEnv: boolean = false) {
    return ConfigService.settings.apiBaseUrl + (includeEnv ? 'env/' + this.siteService.environmentCode + '/' : '');
  }

  siteBaseUrl(includeEnv: boolean = false) {
    if (this.siteService.site == null) {
      throw new Error('No site selected');
    }
    return this.baseUrl(includeEnv) + 'sites/' + this.siteService.site.id + '/';
  }
}
